import React from 'react';
import './banner.scss';

function BannerComercial() {
  return (
    <div className="container-banner" />
  );
}
export default BannerComercial;
